import { render, staticRenderFns } from "./TicketCreateModal.vue?vue&type=template&id=16e7bb55"
import script from "./TicketCreateModal.vue?vue&type=script&lang=ts"
export * from "./TicketCreateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports